module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Airplay-video-ebc1079393f75b97b33e2824808ff343.svg";